export const FALLBACK_LOCALE = 'en_US'

export const LANGUAGE_OPTIONS = [
  { key: 'fr', name: 'Français' },
  { key: 'en', name: 'English' },
]

export const LOCALE_TO_LANG: Readonly<Record<string, string>> = {
  fr_FR: 'fr',
  en_US: 'en',
}

export const LANG_TO_LOCALE_SNAKE: Readonly<Record<string, string>> = {
  fr: 'fr_FR',
  en: 'en_US',
}

export const LANG_TO_LOCALE_KEBAB: Readonly<Record<string, string>> = {
  fr: 'fr-FR',
  en: 'en-US',
}

export const LOCALE_DATE_FORMAT: Readonly<Record<string, string>> = {
  fr: 'DD/MM/YYYY',
  en: 'MM/DD/YYYY',
}
